import type { Template } from "@/types";

export const PO_01_H1_V0: Template[] = [
    {
        id: "po-01-h1v0-01",
        name: "PO 01 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 169, y: 142, width: 959, height: 543, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-02",
        name: "PO 02 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 74, y: 88, width: 1152, height: 652, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-03",
        name: "PO 03 - H1V0",
        albumType: "Hr",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 88, width: 1298, height: 652, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-04",
        name: "PO 04 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 167, y: 0, width: 964, height: 827, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-05",
        name: "PO 05 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 63, y: 59, width: 1170, height: 710, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-06",
        name: "PO 06 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 1298, height: 827, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-07",
        name: "PO 07 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 649, y: 208, width: 649, height: 412, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-08",
        name: "PO 08 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 704, y: 243, width: 538, height: 341, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-09",
        name: "PO 09 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 208, width: 649, height: 412, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-01-h1v0-10",
        name: "PO 10 - H1V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-01-h1_v0_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 56, y: 243, width: 538, height: 341, rotation: 0, imageRotation: 0 }
        ],
    }
];